export const EXCHANGE_PANEL_UI_PROPERTIES_UPDATE =
  'EXCHANGE_PANEL_UI_PROPERTIES_UPDATE'
